export default __webpack_public_path__ + "static/media/star-unselected.13597729.svg";